var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginPageDaskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgexport-6_1_",
    "data-name": "svgexport-6 (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.976,
    height: 45.968,
    viewBox: "0 0 45.976 45.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M46.069,26.616l-3.362-1.441c.011-.065.038-.724.038-.724s.885,1.062,1.8.209l3.134-3.291a1.054,1.054,0,0,0-.1-1.535L25.638,2.231a1.044,1.044,0,0,0-1.311,0l-9.79,7.925V3.045A1.044,1.044,0,0,0,13.492,2H8.269A1.044,1.044,0,0,0,7.224,3.045V16.078L2.388,19.992a1.039,1.039,0,0,0-.081,1.55l3.134,3.134c.864.83,1.783-.226,1.783-.226V46.923a1.044,1.044,0,0,0,1.045,1.045H39.61a1.115,1.115,0,0,0,.518-.138,15.59,15.59,0,0,0,7.84-13.508V29.5A3.131,3.131,0,0,0,46.069,26.616ZM9.313,4.089h3.134v7.76L9.313,14.387ZM6.266,22.548,4.6,20.887l20.384-16.5,20.4,16.365-1.7,1.783L25.626,8.488a1.049,1.049,0,0,0-1.284,0Zm3.035.287,15.683-12.2,15.683,12.2c0,.021-.013,1.461-.013,1.461l-.633-.272a1.041,1.041,0,0,0-.822,0l-6.048,2.591a3.134,3.134,0,0,0-1.9,2.881v4.826a15.593,15.593,0,0,0,5.153,11.557h-6.2V32.3a1.044,1.044,0,0,0-1.045-1.045H20.805A1.044,1.044,0,0,0,19.761,32.3V45.879H9.313S9.3,22.856,9.3,22.835ZM21.85,45.879V33.342h6.268V45.879ZM45.879,34.322A13.5,13.5,0,0,1,39.61,45.7a13.5,13.5,0,0,1-6.268-11.382V29.5a1.045,1.045,0,0,1,.632-.96l5.636-2.415,5.635,2.415a1.043,1.043,0,0,1,.633.96Z",
    transform: "translate(-1.994 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    d: "M24.134,21.268A3.134,3.134,0,1,0,21,18.134,3.138,3.138,0,0,0,24.134,21.268Zm0-4.179a1.045,1.045,0,1,1-1.045,1.045A1.046,1.046,0,0,1,24.134,17.089Z",
    transform: "translate(-1.144 -1.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3923",
    "data-name": "Path 3923",
    d: "M40.5,30.394l-3.45,4.312-1.264-1.264a1.045,1.045,0,0,0-1.477,1.477L36.4,37.008a1.053,1.053,0,0,0,1.555-.087L42.129,31.7a1.044,1.044,0,1,0-1.632-1.3Z",
    transform: "translate(-0.562 -0.748)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageDaskIcon);
export default __webpack_public_path__ + "static/media/login-page-dask-icon.a285660b102c39e63dba48632d5a3664.svg";
export { ForwardRef as ReactComponent };